import { useSelector } from 'react-redux';
import { BetslipVisibility } from '../sportsbook-types';
import useSportsbookBetslip from './use-sportsbook-betslip';
import { selectIsAuthenticated } from '../sportsbook-root-selectors';
import { isSmallerSelector } from '../../../layout/mediaquery';

const useHasLoginFooter = () => {
	const isAuthenticated = useSelector(selectIsAuthenticated);
	const isSmaller = useSelector(isSmallerSelector);

	const { betslipVisibility } = useSportsbookBetslip();

	return !isAuthenticated && isSmaller && betslipVisibility === BetslipVisibility.HIDDEN;
};

export default useHasLoginFooter;
